
'use strict';

const $ = require('jquery');

$(document).ready(function () {
    ReviewToggle();
    $('#review-dropdown-div').hide();

    ReviewToggleMore();
    $('#review-more-dropdown').hide();

    NewsletterToggle();
    $('#newsletter-dropdown-div').hide();

    LinksToggle();
});

function ReviewToggle() {
    $('#review-button').click(function () {
        $('#review-dropdown-div').toggle('slow');
    });
}

function ReviewToggleMore() {
    $('#review-more').click(function () {
        $('#review-more-dropdown').toggle('slow');
    });
}

function NewsletterToggle() {
    $('#newsletter-unsubscribe-toggle').click(function () {
        $('#newsletter-form-unsubscribe').toggle('slow');
    });
}

function LinksToggle() {
    $('#links-toggle').click(function () {
        $('.filters').toggle('slow');
    });
}

$(".show_login").on('click', function(){
    $('body.checkout .main-content .login-form').slideToggle();
});






function checkOutToggle() {
    if ($('#customer-type-business').is(':checked')) {
        $('.business').slideDown('slow');
    } else {
        $('.business').slideUp('slow');
    }

    if ($('#customer-delivery').is(':checked')) {
        $('.delivery-toggle').slideDown();
    } else {
        $('.delivery-toggle').slideUp();
    }
}

checkOutToggle();







$('#customer-delivery').on('change', function () {
    $('.delivery-toggle').stop().slideToggle('slow', 'linear');
});

$('#customer-account').on('change', function () {
    $('.password-input').slideToggle('slow', 'linear');
});


$('[name="type"]').on('change', checkOutToggle);

$('#togglePassword').change(function () {
    if ($(this).is(':checked')) {
        $('#customer-password').attr('type', 'text');
        $('#toggleText').text('Verberg wachtwoord');
    } else {
        $('#customer-password').attr('type', 'password');
        $('#toggleText').text('Toon wachtwoord');
    }
});
